<p>Each canon of Scripture (e.g., Old Testament, New Testament) needs its own parsing format.</p>

@for (item of canonArrays; track item.canon) {
    <mat-card>
    <mat-card-header>
      <mat-card-title>Parsing formats for the {{item.canon}} canon</mat-card-title>
    </mat-card-header>
    <mat-card-content>
    @if( item.parsingFormats.length > 0 ) {
      <mat-list role="list">
      @for( pfc of item.parsingFormats; track pfc.value.id ) {
        <mat-list-item role="listitem">{{pfc.value.id}} 
          <button mat-stroked-button class="margined" (click)="editParsingFormat(item.canon,pfc.value)" type="button">Edit</button>
          <button mat-stroked-button class="margined" (click)="removeParsingFormat(item.canon,pfc.value)" type="button">Remove</button>
        </mat-list-item>
      }
      </mat-list>
    } @else {
      <p>There are no parsing formats for this canon.</p>
    }
    <div id="add-publication-configuration">
      <button mat-button color="secondary" (click)="newParsingFormat(item.canon)" type="button">Add a format...</button>
    </div>
  </mat-card-content>
  </mat-card>
}